<script>
import HeaderRestoAdmin from '@components/navigation/HeaderRestoAdmin';
import FooterRestoAdmin from '@components/navigation/Footer';
import SidebarNav from '@components/navigation/SidebarNav';
import MainNavigation from '@components/navigation/MainNavigation';
import ApiProgress from '@src/plugins/ApiProgress';

export default {
  name: 'MainLayout',
  components: {
    HeaderRestoAdmin,
    SidebarNav,
    MainNavigation,
    FooterRestoAdmin,
  },
  mixins: [ ApiProgress ],
  props: {
    customClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      infoBarExpanded: false,
    };
  },
  computed: {
    pageStyle() {
      return {
        // marginLeft: '50px',
        marginRight: this.infoBarExpanded ? '250px' : '0px',
        transition: 'all 0.3s',
      };
    },
  },
  mounted() {
    window.zE('webWidget', 'show');
  },
};
</script>

<template>
  <div class="min-h-screen bg-grey-lighter flex flex-1 flex-col">
    <div :style="pageStyle" class="flex flex-col flex-1">
      <header-resto-admin />
      <div :class="[customClass, 'px-8 py-4 resto-admin-main-container']" class="px-8 py-4">
        <slot />
      </div>
      <footer-resto-admin />
    </div>

    <sidebar-nav />

  </div>
</template>
